module.exports = __webpack_public_path__ + "static/media/girl_with_dog.e3e58e30.png";